<template>
  <div class="curriculum">
    <h2><span></span>我的课表</h2>
    <div>
      <el-form
        ref="search"
        class="curriculum-search"
        :inline="true"
        :model="condition"
        label-width="80px"
      >
        <div class="curriculum-search_label">
          <el-form-item prop="start_year">
            <el-select
              v-model="condition.start_year"
              placeholder="请选择学年"
              clearable
              filterable
            >
              <el-option
                v-for="item in startYearList"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="start_semester">
            <el-select
              v-model="condition.start_semester"
              placeholder="请选择学期"
              clearable
              filterable
            >
              <el-option
                v-for="item in startSemesterList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="screenClick">确定</el-button>
          </el-form-item>
        </div>
        <!-- <div>
          <el-form-item>
            <span class="curriculum-search_label">日期选择：</span>
            <el-date-picker
              v-model="datetimerange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              @change="datetimeChange">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-date" @click="screenClick">筛选</el-button>
          </el-form-item>
        </div> -->
      </el-form>
    </div>
    <div class="curriculum-tab">
      <el-table
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        :data="list"
        border
        style="width: 100%"
      >
        <el-table-column prop="course_title" label="课程名称" align="center"></el-table-column>
        <el-table-column prop="course_time" label="时间" align="center">
          <template v-slot="{row}">
            <div v-for="(item, index) in row.course_time" :key="index">{{item}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="class_form" label="上课形式" align="center">
          <template v-slot="scoped">
            <pre>{{scoped.row.class_form_title}}</pre>
            <!-- <div v-if="scoped.row.class_form == 2">
              <label>直播地址：</label>
              <el-button type="text" @click="jumpLive(scoped.row)">观看直播</el-button>
            </div> -->
          </template>
        </el-table-column>
        <el-table-column prop="teacher_title" label="任课老师" align="center"></el-table-column>
        <el-table-column prop="exam_type" label="考试方式" align="center">
          <template v-slot="{row}">
            <span>{{row.exam_type | examTypeFilter}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getStartYear, getTimetableApi, courseLiveUrl } from "@/api/basic";
export default {
  name: "Curriculum",
  components: {
  },
  filters: {
    examTypeFilter(v){
      const obj = {
        1: '统考',
        2: '考查',
        3: '毕业设计',
      };
      return obj[v];
    },
  },
  data() {
    return {
      condition:{
        // start_date:"",
        // end_date:"",
        start_year: '',  //学年
        start_semester: '',  //学期
      },
      list:[],
      listTotal:-1,

      startYearList: [],  //学年
      // 开考学期
      startSemesterList: [
        {id: 1, title: '上半学期'},
        {id: 2, title: '下半学期'},
      ],

      datetimerange:[]
    };
  },
  methods: {
    // 点击确定/筛选
    screenClick(){
      this.getListFn();
    },
    // 选择日期
    // datetimeChange(v){
    //   if(this.$base.isNull(v)){
    //     this.condition.start_date = ''
    //     this.condition.end_date = ''
    //     return
    //   }
    //   this.condition.start_date = v[0]
    //   this.condition.end_date = v[1]
    // },
    async getListFn(){
      let params = this.condition;
      const {code,result,msg} = await getTimetableApi(params);
      if(code != 200)return
      this.list = [...result]
      this.listTotal = result.length
    },
    // 获取学年
    getStartYear(){
      getStartYear().then(res => {
        if(res.code == 200){
          this.startYearList = res.result;
        }
      });
    },
    // jumpLive(row){
    //   const data = {
    //     course_id: row.course_id,
    //   };
    //   courseLiveUrl(data).then(res => {
    //     if(res.code == 200){
    //       window.open(res.result.data);
    //     }
    //   });
    // }
  },
  created() {
    this.getStartYear();  //获取学年
    this.getListFn();
  },
  beforeDestroy() {

  }
};
</script>

<style lang="scss" scoped>
.curriculum {
  min-height:$sideBarH;
  margin: 20px;
  padding: 20px;
  background: $white;
  h2{
    display: flex;
    align-items: center;
    span{
      width: 4px;
      height: 20px;
      background: $primary;
      margin-right: 10px;
    }
  }
  &-search{
    display: flex;
    justify-content: space-between;
    align-items: center;
    ::v-deep{
      .el-date-editor{
        width: 400px;
        .el-range-separator{
          width: 30px;
        }
      }
    }
  }
}
</style>
